const validate = (key) => key && key !== '';

export default validate;
